import Styles from './ProfileDropdown.module.scss'
import { Drawer } from 'components/Drawer'
import { DrawerProps } from 'components/Drawer/Root'
import { observer } from 'mobx-react-lite'
import { CurrentView } from './ProfileDropdown'
import { Key, useState } from 'react'
import { WorkspacesMenu } from './components/WorkspacesMenu/WorkspacesMenu'
import { MainMenu } from './components/MainMenu/MainMenu'
import { useRootStore } from 'stores/RootStore'
import { SettingsMember, Workspace } from 'types'
import { useAPMobileWeb } from 'hooks/useAPMobileWeb'

type Props = DrawerProps & {
  handleAction: (key: Key, close: () => void) => void
  selectedWorkspace: Workspace
  workspaces: Workspace[]
  profile?: SettingsMember
}

export const ProfileDrawer = observer((props: Props) => {
  const { handleAction: _handleAction, selectedWorkspace, workspaces, profile } = props
  const { drawersStore } = useRootStore()
  const [currentView, setCurrentView] = useState(CurrentView.MainMenu)
  const close = () => drawersStore.closeAllDrawers()

  const handleAction = (key: Key, close: () => void) => {
    if (key === 'switchWorkspace') {
      setCurrentView(CurrentView.SwitchWorkspace)
      return
    }
    return _handleAction(key, close)
  }

  const renderContent = () => {
    if (currentView === CurrentView.SwitchWorkspace) {
      return (
        <WorkspacesMenu
          onBack={() => setCurrentView(CurrentView.MainMenu)}
          onAction={(key) => handleAction(key, close)}
          onClose={close}
          workspaces={workspaces}
          workspaceId={selectedWorkspace.id}
          hideHeading
        />
      )
    }

    return <MainMenu onAction={(key) => handleAction(key, close)} workspace={selectedWorkspace} profile={profile} />
  }

  const isAPMobileWeb = useAPMobileWeb()

  return (
    <Drawer.Root activeSnapPoint={1} snapPoints={[1]} {...props}>
      <Drawer.Portal>
        <Drawer.Content fullHeight>
          <Drawer.InnerContent fullHeight>
            <Drawer.Top>
              {currentView === CurrentView.SwitchWorkspace ? (
                <Drawer.Back onPress={() => setCurrentView(CurrentView.MainMenu)} />
              ) : (
                <div />
              )}
              <Drawer.Title></Drawer.Title>
              <Drawer.Close label="Close" variant={isAPMobileWeb ? 'editor' : 'ghost'} position="right" />
            </Drawer.Top>
            <Drawer.Container className={Styles.drawerContainer}>{renderContent()}</Drawer.Container>
          </Drawer.InnerContent>
        </Drawer.Content>
      </Drawer.Portal>
    </Drawer.Root>
  )
})
